// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import visitEntity from './entities/visit.json';
import visitMenu from '../pages/visit/menu.json';
import visitFullForm from '../pages/visit/forms/full.json';
import visitContextForm from '../pages/visit/forms/context.json';
import visitMiniForm from '../pages/visit/forms/mini.json';
import visitLookupForm from '../pages/visit/forms/lookup.json';
import visitTableView from '../pages/visit/views/table.json';
import visitStagesView from '../pages/visit/views/stages.json';
import visitCardsView from '../pages/visit/views/cards.json';
import visitSplitView from '../pages/visit/views/split.json';
import visitCalendarView from '../pages/visit/views/calendar.json';
import visitDashboardView from '../pages/visit/views/dashboard.json';

/** Тип запису «Візит» зі сторінками пакета: меню, форми та подання з pages/visit/. */
export const visitDefinition: IRecordTypeDefinition = {
  ...visitEntity,
  views: assembleViewSet({
      table: visitTableView,
      stages: visitStagesView,
      cards: visitCardsView,
      split: visitSplitView,
      calendar: visitCalendarView,
      dashboard: visitDashboardView,
  }),
  form: visitFullForm,
  forms: { full: visitFullForm, context: visitContextForm, mini: visitMiniForm, lookup: visitLookupForm },
  menu: visitMenu,
} as IRecordTypeDefinition;
